var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name == 'Dashboard' || _vm.$route.name == 'Surveys')?_c('app-header',{staticClass:"uk-margin-bottom"}):_vm._e(),_c('div',{attrs:{"id":"content-wrap"}},[_c('router-view')],1),(!_vm.appInited)?_c('loading-spinner'):_vm._e(),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }